import { useSyncExternalStore } from "react";

import { Conversations } from "@/lib/conversation-session";

export function useConversationSession(personId: number) {
	const session = Conversations.forPerson(personId);
	const draft = useSyncExternalStore(session.subscribe, session.snapshot);

	return { session, draft };
}
